import React from "react";
import { PERIODS } from "../config/periods";

// Controlled pill group. Options come from config so an unsupported period
// can never reach the API.
const PeriodFilter = function (props) {
  const { value, onChange, disabled } = props;

  return (
    <div className="tn-pillgroup" role="group" aria-label="Reporting period">
      {PERIODS.map(function (period) {
        const active = period.key === value;
        return (
          <button
            key={period.key}
            type="button"
            disabled={disabled}
            aria-pressed={active}
            className={"tn-pill" + (active ? " tn-pill-active" : "")}
            onClick={function () {
              if (!active) onChange(period.key);
            }}
          >
            {period.label}
          </button>
        );
      })}
    </div>
  );
};

export default PeriodFilter;
